module.exports = __webpack_public_path__ + "img/image4.a6bc3e8c.png";